import { useTranslation } from 'react-i18next';
import classes from './Benefits.module.scss';
import image from '../../../assets/img/MechanicalWorks/benefits.avif';

const Benefits = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <img className={classes.image} src={image} alt='' />
                <div className={classes.content}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('mechanical.benefits.title')}
                    </h2>
                    <ul className={`${classes.list} font-16`}>
                        <li>{t('mechanical.benefits.li_01')}</li>
                        <li>{t('mechanical.benefits.li_02')}</li>
                        <li>{t('mechanical.benefits.li_03')}</li>
                        <li>{t('mechanical.benefits.li_04')}</li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Benefits;
